import { useState, useEffect } from 'react'
import { Chart } from 'primereact/chart'
import { useAppSelector } from '../../../store/hooks'
import { chartColorVariants } from './chartsUtil'

const PolarChart = ({ data }) => {
    const theme = useAppSelector((state) => state.theme.theme)

    const [chartData, setChartData] = useState({})
    const [chartOptions, setChartOptions] = useState({})

    useEffect(() => {
        const documentStyle = getComputedStyle(document.documentElement)
        const textColor = documentStyle.getPropertyValue(
            theme === 'dark' ? '--bs-white' : '--bs-black'
        )
        const surfaceBorder =
            documentStyle.getPropertyValue('--bs-border-color')

        const options = {
            plugins: {
                legend: {
                    labels: {
                        color: textColor,
                    },
                },
            },
            scales: {
                r: {
                    grid: {
                        color: surfaceBorder,
                    },
                },
            },
        }

        let finalisedChartData = data
        let ds = data?.['datasets']?.[0] || {}
        const dsData = ds['data'] || []

        ds['borderColor'] = []
        ds['backgroundColor'] = []

        for (const i in dsData) {
            const colorVariant = chartColorVariants[i]

            if (colorVariant) {
                ds['borderColor'].push(
                    documentStyle.getPropertyValue('--bs-' + colorVariant)
                )
                ds['backgroundColor'].push(
                    documentStyle.getPropertyValue('--bs-' + colorVariant) +
                        '80'
                )
            }
        }

        setChartData(finalisedChartData)
        setChartOptions(options)
    }, [theme, data])

    return (
        <Chart
            type="polarArea"
            data={chartData}
            options={chartOptions}
            className="p-2"
        />
    )
}

export default PolarChart
